import React, { useState } from "react";
import UnsubscribeComponent from "./unsbscribe";
import Notify from "../common/notify/notify";
import { connect } from "react-redux";
import { userUnsubscribe } from "../../redux/slice/userUnsubscribeSlice";

const Unsubscribe = (props) => {
  const { calluserUnsubscribeData, userUnsubscribeData } = props;

  const [formData, setFormData] = useState({
    phone_number: "",
    code: "",
  });

  const [validation, setValidation] = useState({});
  const loading = userUnsubscribeData.isLoading;

  const handleUnsubscribe = (event) => {
    const { name, value } = event.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setValidation((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleSubmit = async () => {
    let error = {};

    if (!formData.phone_number) {
      error.phone_number = "Please Enter A Phone Number";
    } else if (!/^\d{10,12}$/.test(formData.phone_number.toString())) {
      error.phone_number = "Please Enter A Valid Phone Number (10–12 digits)";
    }

    if (!formData.code) {
      error.code = "Please Enter PIN";
    }

    setValidation(error);

    if (Object.keys(error).length === 0) {
      try {
        const loginResult = await calluserUnsubscribeData({
          ...formData,
          phone_number: Number(formData.phone_number),
        });

        if (loginResult?.type === "userUnsubscribe/rejected") {
          Notify(
            "error",
            loginResult.error?.message || "Unsubscribe failed.",
            ""
          );
          return;
        }

        if (loginResult?.type === "userUnsubscribe/fulfilled") {
          Notify("success", "You have been unsubscribed successfully!", "");
        }
      } catch (err) {
        Notify(
          "error",
          "Oops! Something went wrong. Please try again later.",
          ""
        );
      }
    }
  };

  const handelotp = (event) => {
    setFormData((prevState) => ({
      ...prevState,
      code: Number(event),
    }));

    setValidation((prevState) => ({
      ...prevState,
      code: "",
    }));
  };

  return (
    <div>
      <UnsubscribeComponent
        handleSubmit={handleSubmit}
        handleUnsubscribe={handleUnsubscribe}
        validation={validation}
        handelotp={handelotp}
        loading={loading}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userUnsubscribeData: state.userUnsubscribeData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    calluserUnsubscribeData: (data) => dispatch(userUnsubscribe(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Unsubscribe);
